import i18next from 'i18next'
import * as React from 'react'
import { Link } from 'widgets-for-react'
import { DataLayer } from '../../../../utils/datalayer'

export const ComponentSaverLayout = {
  EmptyCollections: () => (
    <p>{i18next.t('collection:modalTextSaveInCollectionEmpty')}</p>
  ),
  MultipleCollections: ({ children }: { children: React.ReactNode }) => (
    <fieldset className="styled-bools sb sb--full sb--checkbox">
      <legend className="sr-text">
        {i18next.t('collection:yourCollections')}
      </legend>
      {children}
    </fieldset>
  ),
  CollectionSelector: ({
    name,
    id,
    latestComponents,
    isChecked,
    onChange,
  }: {
    name: string
    id: string
    latestComponents?: string[]
    isChecked: boolean
    onChange: () => void
  }) => (
    <div className="sb__bool">
      <input
        type="checkbox"
        name="sb-collection"
        className="sb__input form-check-input"
        checked={isChecked}
        onChange={onChange}
        id={`sb-${id}`}
      />
      <label className="sb__label" htmlFor={`sb-${id}`}>
        <span className="sb__title">{name}</span>
        {latestComponents && latestComponents.length > 0 ? (
          <>
            <span className="sr-text">{`${i18next.t(
              'component:latestComponents'
            )}:`}</span>
            <ul className="sb__list">
              {latestComponents.map((component) => (
                <li
                  className="sb__item text--xs"
                  key={component}
                  dangerouslySetInnerHTML={{ __html: component }}
                />
              ))}
            </ul>
          </>
        ) : (
          <p
            className="text--xs"
            dangerouslySetInnerHTML={{
              __html: i18next.t('component:latestComponentsEmpty'),
            }}
          />
        )}
      </label>
    </div>
  ),
  Succes: ({
    savedCollections,
    deletedCollections,
  }: {
    savedCollections: { Id: string; Name: string }[]
    deletedCollections: { Id: string; Name: string }[]
  }) => (
    <div className="text--styled">
      {savedCollections.length > 0 && (
        <>
          <p>{i18next.t('collection:modalTextSaveInCollectionSuccess')}</p>
          <ul>
            {savedCollections.map((c) => (
              <li key={c.Id}>
                <Link
                  onClick={() => DataLayer.goToCollection('component')}
                  to={
                    i18next.language == 'en'
                      ? `/en/dashboard/collection/${c.Id}`
                      : `/nl/dashboard/collectie/${c.Id}`
                  }
                >
                  {c.Name}
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
      {deletedCollections.length > 0 && (
        <>
          <p>{i18next.t('collection:modalTextDeleteFromCollectionSuccess')}</p>
          <ul>
            {deletedCollections.map((c) => (
              <li key={c.Id}>
                <Link
                  to={
                    i18next.language == 'en'
                      ? `/en/dashboard/collection/${c.Id}`
                      : `/nl/dashboard/collectie/${c.Id}`
                  }
                >
                  {c.Name}
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  ),
  SaveDeleteFailed: () => (
    <p>{i18next.t('collection:modalTextSaveDeleteFromCollectionFailed')}</p>
  ),
  CollectionsLoadingFailed: () => (
    <p>
      {i18next.t('common:loadingFailed', {
        entity: i18next.t('collection:collectionsTitle').toLowerCase(),
      })}
    </p>
  ),
  CreateAccount: () => <p>{i18next.t('collection:modalTextCreateAccount')}</p>,
}
